export default __webpack_public_path__ + "static/media/ProximaNova-Extrabld.026a945d.ttf";